var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cw-invoice-list"},_vm._l((_vm.invoices),function(invoice){return _c('cw-invoice-cell',{key:invoice.id,attrs:{"invoice":invoice,"displayPaymentInfo":_vm.displayPaymentInfo},on:{"click":function($event){return _vm.selectionHandler(invoice)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }